// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4607":"513c447b","9296":"513c447b"}[chunkId] + ".chunk.css";
};